<template>
  <v-form ref="form" style="border-radius: 18px;" v-model="valid" lazy-validation @close="close" @submit="submit">
    <v-card>
      <v-card-title class="mb-4">
        <span class="text-h5">Список квартир домофона № {{ doorphone.id }}</span>
      </v-card-title>
        <v-card-text>
          <p>
            При выборе нужного sip логина можно его скопировать <v-icon small class="ml-1"> mdi-content-copy</v-icon>
          </p>
          <v-data-table
            class="table"
            :headers="displayTable"
            :items="listApartments"
            :items-per-page="10"
            :footer-props="{
                'items-per-page-options': [5, 10, 50, 100],
            }"
          >
            <template v-slot:item.Phone1="{ item }">
              <div v-if="item.Phone1">
                {{ item.Phone1 }}
                <v-icon
                  small
                  class="ml-2"
                  @click="copyToClipboard(item.Phone1)"
                >
                  mdi-content-copy
                </v-icon>
              </div>
            </template>
            <template v-slot:item.Phone2="{ item }">
              <div v-if="item.Phone2">
                {{ item.Phone2 }}
                <v-icon
                small
                class="ml-2"
                @click="copyToClipboard(item.Phone2)"
                >
                  mdi-content-copy
                </v-icon>
              </div>
            </template>
            <template v-slot:item.Replace="{ item }">
              <div v-if="item.Replace">
                {{ item.Replace }}
                <v-icon
                  small
                  class="ml-2"
                  @click="copyToClipboard(item.Replace)"
                >
                  mdi-content-copy
                </v-icon>
              </div>
            </template>
            <template v-slot:item.Login="{ item }">
              <div v-if="item.Login">
                {{ item.Login }}
                <v-icon
                  small
                  class="ml-2"
                  @click="copyToClipboard(item.Login)"
                >
                  mdi-content-copy
                </v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import { headersRulesShortRubetek3438, headersRulesShortRubetek3434, headersRulesShortBeward } from '../../doorphone/DetailDoorphone/consts';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    listApartments: {
      type: Array,
      required: true,
    },
    doorphone: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: true,
    headersRulesShortRubetek3438,
    headersRulesShortRubetek3434,
    headersRulesShortBeward,
    lastCopiedText: null,
  }),
  created () {
  },
  computed: {
    ...mapGetters({
      rules: 'Doorphone/rules',
    }),
    displayTable () {
      if (this.doorphone.model === 'RV-3438') {
        return this.headersRulesShortRubetek3438;
      }
      if (this.doorphone.model === 'RV-3434') {
        return this.headersRulesShortRubetek3434;
      } else {
        return this.headersRulesShortBeward;
      }
    },
  },
  methods: {
    ...mapActions({
      getCallStart: 'Doorphone/getCallStart',
      callCheck: 'Doorphone/callCheck',
      getCallEnd: 'Doorphone/getCallEnd',
    }),
    async copyToClipboard (value) {
      if (this.lastCopiedText === value) {
        return;
      }
      try {
        await navigator.clipboard.writeText(value);
        this.lastCopiedText = value;
        this.$flash_success('sip логин скопирован!');
      } catch (err) {
        this.$flash_danger('Не удалось скопировать sip логин');
      }
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss">
.row-click {
  cursor: pointer;
}
</style>
